import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPatchRequest } from '../../../api/requestUtil';

export const toggleUpvoteFeaturedArticle = createAsyncThunk(
  'featuredArticleUpvote/toggle',
  async (articleId: number, { getState }) => {
    const state = getState() as AppState;
    const token = state.user.authToken;
    try {
      const response = await sendPatchRequest(
        `/api/articles/${articleId}/upvote/`,
        {},
        token
      );

      return response;
    } catch (error) {
      throw new Error('Failed to toggle upvote');
    }
  }
);

export const fetchUpvoteFeaturedArticleStatus = createAsyncThunk(
  'featuredArticleUpvote/fetchStatus',
  async (articleId: number, { getState }) => {
    const {
      user: { authToken },
    } = getState() as AppState;
    return sendGetRequest(
      `/api/articles/${articleId}/upvote-status/`,
      authToken || null
    );
  }
);
